import type { AsyncData } from "#app";
import type { NitroFetchOptions } from "nitropack";
import type { UseApiFetchOptions } from "@edco/apollo/dist/runtime/composables/useApiFetch";

export function $auditResource () {
  const dependencies = useFetchDependencies();

  function logPageView (contentNodeIdOrKey: number | string) {
    const url = `/api/isn/audit/pageview/${contentNodeIdOrKey}`;
    const options: NitroFetchOptions<string> = {
      method: "POST",
    };

    return $apiFetch<void>(url, options, dependencies);
  }

  function logLogin() {
    const url = "/api/isn/audit/login";
    const options: NitroFetchOptions<string> = {
      method: "POST",
    };

    return $apiFetch<void>(url, options, dependencies);
  }

  return {
    logPageView,
    logLogin,
  };
}

export function useAuditResource () {
  function logPageView(contentNodeIdOrKey: number | string): AsyncData<null, Error | null> {
    const url = `/api/isn/audit/pageview/${contentNodeIdOrKey}`;
    const options: UseApiFetchOptions<null> = {
      method: "POST",
    };

    return useApiFetch<null>(url, options);
  }

  function logLogin(): AsyncData<null, Error | null> {
    const url = "/api/isn/audit/login";
    const options: UseApiFetchOptions<null> = {
      method: "POST",
    };

    return useApiFetch<null>(url, options);
  }

  return {
    logPageView,
    logLogin,
  };
}
